// import React from "react";
// import "./Orders.css";

// import { useEffect, useState } from 'react';
// import { useNavigate } from "react-router-dom";
// function Orders() {
//   // const [orders, setOrders] = useState([]);
//   // const [cart, setCart] = useState([]);
//   // const [currentPage, setCurrentPage] = useState(1);
//   // const ordersPerPage = 5;
//   // const indexOfLastOrder = currentPage * ordersPerPage;
//   // const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
//   // const currentOrders = orders.slice(indexOfFirstOrder, indexOfLastOrder);
//   // const totalPages = Math.ceil(orders.length / ordersPerPage);
//   // const paginate = (pageNumber) => setCurrentPage(pageNumber);
//   // const navigate = useNavigate();

//   // const fetchOrders = async (token) => {
//   //   try {
//   //     console.log("token", token);
//   //     const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/retrive-order',{
//   //       method: 'POST',
//   //       headers: {
//   //         'Content-Type': 'application/json',
//   //       },
//   //       body: JSON.stringify({
//   //         "token": token
//   //       }),
//   //     });
//   //     const data = await response.json();
//   //     const cleanedBody = data.body.replace(/NaN/g, "null");
//   //     const parsedData = JSON.parse(cleanedBody);
//   //     console.log("data from orders", parsedData);
//   //     return parsedData;
//   //   } catch (error) {
//   //     console.error('Error fetching orders:', error);
//   //   }
//   // };

//   // useEffect(() => {
//   //   // Fetch order data from backend
//   //   const fetch = async () => {
//   //     const token = localStorage.getItem('token');
//   //     const data= await fetchOrders(JSON.parse(token));
//   //     setOrders(data);
//   //   };
//   //   fetch();
//   // }, []);

//   const [orders, setOrders] = useState([]);
//   const [cart, setCart] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const ordersPerPage = 5;
//   const navigate = useNavigate();

//   // Memoize pagination calculations for better performance
//   const paginationData = React.useMemo(() => {
//     const indexOfLastOrder = currentPage * ordersPerPage;
//     const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
//     const currentOrders = orders.slice(indexOfFirstOrder, indexOfLastOrder);
//     const totalPages = Math.ceil(orders.length / ordersPerPage);

//     return {
//       indexOfLastOrder,
//       indexOfFirstOrder,
//       currentOrders,
//       totalPages
//     };
//   }, [orders, currentPage]);

//   const fetchOrders = async (token) => {
//     try {
//       const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/retrive-order', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ token }),
//       });

//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const data = await response.json();

//       if (!data.body) {
//         throw new Error('Invalid response format');
//       }

//       const cleanedBody = data.body.replace(/NaN/g, "null");
//       const parsedData = JSON.parse(cleanedBody);

//       return Array.isArray(parsedData) ? parsedData : [];
//     } catch (error) {
//       console.error('Error fetching orders:', error);
//       throw error;
//     }
//   };

//   // Validate current page whenever orders length or current page changes
//   useEffect(() => {
//     if (currentPage < 1) {
//       setCurrentPage(1);
//     } else if (paginationData.totalPages > 0 && currentPage > paginationData.totalPages) {
//       setCurrentPage(paginationData.totalPages);
//     }
//   }, [currentPage, paginationData.totalPages]);

//   useEffect(() => {
//     const fetchData = async () => {
//       setIsLoading(true);
//       setError(null);

//       try {
//         const token = localStorage.getItem('token');
//         if (!token) {
//           throw new Error('No authentication token found');
//         }

//         const data = await fetchOrders(JSON.parse(token));
//         setOrders(data);
//       } catch (err) {
//         setError(err.message || 'Failed to fetch orders');
//         console.error('Error:', err);
//         setOrders([]); // Reset orders on error
//       } finally {
//         setIsLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   const paginate = (pageNumber) => {
//     if (pageNumber >= 1 && pageNumber <= paginationData.totalPages) {
//       setCurrentPage(pageNumber);
//     }
//   };

//   if (isLoading) {
//     return <div>Loading orders...</div>;
//   }

//   if (error) {
//     return <div>Error: {error}</div>;
//   }

//   return (
//     <div>
//       <div className="orders-table-container">
//         <table className="styled-table">
//           <thead>
//             <tr>
//               <th>Order</th>
//               <th>Date</th>
//               <th>Status</th>
//               <th>Total</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentOrders.map((order) => (
//               <tr key={order.order_id}>
//                 <td className="order-id">{order?.order_id}</td>
//                 <td className="order-date">{order?.created_at?.split('')[0]}</td>
//                 <td className="order-status">{order?.order_status}</td>
//                 <td className="order-total">{order?.total_price}</td>
//                 <td className="order-actions">
//                   <button className="view-btn" onClick={() => navigate(`/my-account/order-details/${order.order_id}`)}>View</button>
//                   <button className="messages-btn">View Order Messages</button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>



//       <div className="pagination">
//         <button
//           className="page-number"
//           disabled={currentPage === 1}
//           onClick={() => paginate(currentPage - 1)}
//         >
//           Previous
//         </button>
//         {[...Array(totalPages)].map((_, index) => (
//           <button
//             key={index}
//             onClick={() => paginate(index + 1)}
//             className={`page-number ${currentPage === index + 1 ? "active" : ""}`}
//           >
//             {index + 1}
//           </button>
//         ))}
//         <button
//           className="page-number"
//           disabled={currentPage === totalPages}
//           onClick={() => paginate(currentPage + 1)}
//         >
//           Next
//         </button>
//       </div>

//     </div>
//   );
// };

// export default Orders;



import React, { useEffect, useState } from "react";
import "./Orders.css";
import { useNavigate } from "react-router-dom";

function Orders() {
  const [orders, setOrders] = useState([]);
  const [cart, setCart] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [noOrders, setNoOrders] = useState(false);

  const ordersPerPage = 5;
  const navigate = useNavigate();

  // Memoize pagination calculations for better performance
  const paginationData = React.useMemo(() => {
    const indexOfLastOrder = currentPage * ordersPerPage;
    const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
    const currentOrders = orders.slice(indexOfFirstOrder, indexOfLastOrder);
    const totalPages = Math.ceil(orders.length / ordersPerPage);

    return {
      indexOfLastOrder,
      indexOfFirstOrder,
      currentOrders,
      totalPages
    };
  }, [orders, currentPage]);

  const fetchOrders = async (token) => {
    try {
      const response = await fetch('https://qixve8qntk.execute-api.ap-south-1.amazonaws.com/dev/retrive-order', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.body) {
        throw new Error('Invalid response format');
      }

      const cleanedBody = data.body.replace(/NaN/g, "null");
      const parsedData = JSON.parse(cleanedBody);
      //console.log("parsedData from orderpage ", parsedData);
      return Array.isArray(parsedData) ? parsedData : [];
    } catch (error) {
      console.error('Error fetching orders:', error);
      throw error;
    }
  };

  const calculateTotalAmount = (cart) => {
    const cleanedBody = cart.replace(/NaN/g, "null");
    const parsedData = JSON.parse(cleanedBody);
    //console.log("parsedData from orderpage cart", parsedData);

    let total;
    if (parsedData.length > 0) {
      total = parsedData.reduce((acc, item) => acc + item.price * item.quantity, 0);
    } else {
      total = 0;
    }
    //console.log("total", total);
    return total;
  }

  useEffect(() => {
    if (currentPage < 1) {
      setCurrentPage(1);
    } else if (paginationData.totalPages > 0 && currentPage > paginationData.totalPages) {
      setCurrentPage(paginationData.totalPages);
    }
  }, [currentPage, paginationData.totalPages]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setError(null);

      try {
        const token = localStorage.getItem('token');
        if (!token) {
          throw new Error('No authentication token found');
        }

        const data = await fetchOrders(JSON.parse(token));
        setOrders(data);
        if (data.length === 0) {
          setNoOrders(true);
        } else {
          setNoOrders(false);
        }


      } catch (err) {
        setError(err.message || 'Failed to fetch orders');
        console.error('Error:', err);
        setOrders([]); // Reset orders on error
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= paginationData.totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  if (isLoading) {
    return <div>Loading orders...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    (
      (noOrders) ?
        (
          <p>You have no orders</p>
        )
        :
        (<div>
          <div className="orders-table-container">
            <table className="styled-table">
              <thead>
                <tr>
                  <th>Order</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th>Total</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {paginationData.currentOrders
                  .filter((order) => order.order_status !== "Order initiated")
                  .map((order) => (
                    <tr key={order.order_id}>
                      <td className="order-id">{order?.order_id}</td>
                      <td className="order-date">{order?.created_at}</td>
                      <td className="order-status">{order?.order_status}</td>
                      <td className="order-total">{calculateTotalAmount(order?.cart)}</td>
                      <td className="order-actions">
                        <button className="view-btn" onClick={() => navigate(`/my-account/order-details/${order.order_id}`)}>View</button>
                        <button className="messages-btn">View Order Messages</button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          <div className="pagination">
            <button
              className="page-number"
              disabled={currentPage === 1}
              onClick={() => paginate(currentPage - 1)}
            >
              Previous
            </button>
            {[...Array(paginationData.totalPages)].map((_, index) => (
              <button
                key={index}
                onClick={() => paginate(index + 1)}
                className={`page-number ${currentPage === index + 1 ? "active" : ""}`}
              >
                {index + 1}
              </button>
            ))}
            <button
              className="page-number"
              disabled={currentPage === paginationData.totalPages}
              onClick={() => paginate(currentPage + 1)}
            >
              Next
            </button>
          </div>
        </div>
        )
    )

  );
}

export default Orders;